/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sync.health.rpc.RecordsQueryService
 */

export let ComHubspotSyncHealthModelsRecordExportAbstractExportRecordsError;
(function (_ComHubspotSyncHealthModelsRecordExportAbstractExportRecordsError) {})(ComHubspotSyncHealthModelsRecordExportAbstractExportRecordsError || (ComHubspotSyncHealthModelsRecordExportAbstractExportRecordsError = {}));
export let ComHubspotSyncHealthModelsRecordListAbstractGetRecordsError;
(function (_ComHubspotSyncHealthModelsRecordListAbstractGetRecordsError) {})(ComHubspotSyncHealthModelsRecordListAbstractGetRecordsError || (ComHubspotSyncHealthModelsRecordListAbstractGetRecordsError = {}));
export const getRecordsRpc = {
  serviceName: 'com.hubspot.sync.health.rpc.RecordsQueryService',
  rpcName: 'getRecords',
  auth: 'app',
  fingerprint: 'qyDkWwJW3jQ7aLmJHNq5bSgPOLgak2pG',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const exportRecordsRpc = {
  serviceName: 'com.hubspot.sync.health.rpc.RecordsQueryService',
  rpcName: 'exportRecords',
  auth: 'app',
  fingerprint: '3BLJgsti-EA367IIDaeMbw1HHTmO7weO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};